import React from "react";
import UpdateTicketSAVEchanges from "../UpdateTicketSavAdmin/UpdateSavTabContent/UpdateSavContentEchanges";

function NewSAVComment({
  scrollableComment,
  isAdmin,
  notificationCount,
  setScrollableComment,
}) {
  return (
    <UpdateTicketSAVEchanges
      scrollableComment={scrollableComment}
      activeTab={isAdmin ? "Admin notes" : "Comments"}
      notificationCount={notificationCount}
      setScrollableComment={setScrollableComment}
    />
  );
}

export default NewSAVComment;
